import FadeIn from '@/components/shared/FadeIn';

const STATS = [
  { value: '10M+', label: 'Square feet documented', sublabel: 'across commercial, residential & industrial projects' },
  { value: '2017', label: 'Established', sublabel: 'nearly a decade of construction documentation expertise' },
  { value: '150+', label: 'Firms served', sublabel: 'from specialty subcontractors to major developers' },
];

const CredibilitySection: React.FC = () => {
  return (
    <section className="relative overflow-hidden min-h-[80vh] flex items-center">
      {/* Full-bleed background */}
      <img
        src="/static/images/sf2_1600.png"
        alt="Construction site at night"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />

      {/* Dark gradient overlay — heavier at bottom and top */}
      <div className="absolute inset-0 bg-gradient-to-b from-maintenance-dark/70 via-maintenance-dark/50 to-maintenance-dark/90" />
      {/* Side vignettes */}
      <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-maintenance-dark/60 to-transparent" />
      <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-maintenance-dark/60 to-transparent" />

      <div className="relative z-10 w-full container mx-auto px-6 md:px-12 lg:px-16 py-24">
        {/* Top label */}
        <FadeIn>
          <p className="text-maintenance-cyan text-xs uppercase tracking-widest font-semibold mb-6">
            Trusted. Proven. Experienced.
          </p>

          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white leading-tight mb-20 max-w-2xl">
            Numbers that speak for themselves.
          </h2>
        </FadeIn>

        {/* Stat grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 border-l border-white/10">
          {STATS.map((stat, i) => (
            <FadeIn key={stat.value} delay={i * 120} className="border-r border-white/10 px-8 md:px-10 py-8 md:py-10">
              <div className="text-6xl md:text-7xl lg:text-8xl font-black text-white leading-none mb-3 tracking-tight">
                {stat.value}
              </div>
              <div className="text-white text-lg font-semibold mb-1">{stat.label}</div>
              <div className="text-white/40 text-sm leading-relaxed">{stat.sublabel}</div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CredibilitySection;
